import { StoreDataSchema } from "./store.data";

/**
 * Version number for the Key Store Model schema
 */
export type KeyModelVersion = 0;

/**
 * Key-specific data stored in the vault
 */
export interface IKeyStoreData {
  /**
   * **Username**
   *
   * The username associated with this key
   */
  unm?: string;

  /**
   * **Password**
   *
   * The password associated with this key
   */
  pwd?: string;

  /**
   * **API Key**
   *
   * The actual API key value used for authentication with plugins
   */
  ak: string;
}

/**
 * Key Store Model
 *
 * Represents a cryptographic key stored in the vault with associated metadata
 */
export type KeyStoreModel = StoreDataSchema<KeyModelVersion, IKeyStoreData>;

/**
 * Default values for a new Key Store Model instance
 */
export const DefaultKeyStoreModel: KeyStoreModel = {
  id: "",
  dc: "",
  dm: "",
  v: 0,
  vid: "",
  ak: "",
};
